import { FleekError } from './FleekError';

type UploadProxyUploadFileErrorOptions = Record<string, never>;

export class UploadProxyUploadFileError extends FleekError<UploadProxyUploadFileErrorOptions> {
  public name = 'UploadProxyUploadFileError';

  constructor() {
    super({});
  }

  toString = () => `Failed to Upload file.`;
}
